<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/productList' }">产品</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                    <draggableDetail :draggable="{ data_name: 'product' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                (item.prop == 'code' && data['rid'] != '') ||
                                                (item.prop == 'name' && data['rid'] != '') ||
                                                (item.prop == 'product_common_name' && data['product_licence_rid'] != '') ||
                                                (item.prop == 'product_licence_number' && data['product_licence_rid'] != '') ||
                                                (item.prop == 'manufacturer_name' && data['manufacturer_rid'] != '') ||
                                                (item.prop == 'master_name' && data['master_rid'] != '')
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="产品别名" name="3">
                    <vProductFlowComponent v-if="flag" :postList="postList3"></vProductFlowComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="产品期间" name="2">
                    <vProductPeriodComponent v-if="flag" :postList="postList2"></vProductPeriodComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import vProductFlowComponent from '../../listComponent/basicdata/productFlow/productFlowComponent.vue';
import vProductPeriodComponent from '@/components/page/listComponent/basicdata/product/productPeriodComponent.vue';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'productDetails',
    components: {
        vProductFlowComponent,
        draggableDetail,
        vProductPeriodComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '3', '2'],
            data: {},
            queryParams: {},
            headerTitle: '产品详情',
            postList3: {},
            postList2: {},
            flag: false // 所有的明细列表公用一个flag
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.initListsParams();
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initListsParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initListsParams() {
            this.postList3 = {
                headerTitle: false,
                source_product_code: true,
                source_entity_account_rid: true,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                params: {
                    product_rid: this.queryParams.rid
                }
            };
            this.postList2 = {
                product_rid: false,
                params: {
                    product_rid: this.queryParams.rid
                }
            };
        },
        toDetail(prop) {
            if (in_array(prop, ['product_common_name', 'product_licence_number']) && this.data.product_licence_rid != '') {
                this.$router.push({
                    path: '/productDetails',
                    query: {
                        id: this.data.product_licence_rid
                    }
                });
            } else if (prop == 'manufacturer_name' && this.data.manufacturer_rid != '') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.manufacturer_rid
                    }
                });
            } else if (prop == 'master_name' && this.data.master_rid != '') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.master_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).product;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'productDelete', this.data.name, 'productList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'productListEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'productListEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'productListEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .productDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.code;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>